import React from 'react';

const AccordionContext = React.createContext({});

export default AccordionContext;
